// Module
var code = "<p>Enable this setting to allow your respondents to promote your survey easily from the Public results page.</p> ";
// Exports
module.exports = code;